/**
 * 修复 JSON 解析修补遗留：连续「而无」。
 * 例：`「至少「改为「至多「` → `「至少」改为「至多」`
 */
export function repairPairedCornerQuotes(text: string): string {
  const raw = String(text || '');
  if (!raw.includes('「')) return raw;
  let open = true;
  return raw.replace(/「/g, () => {
    const ch = open ? '「' : '」';
    open = !open;
    return ch;
  });
}
